import { useI18n } from "@/lib/i18n";

const STEP_KEYS = [
  { n: "01", key: "agency.how.s1" },
  { n: "02", key: "agency.how.s2" },
  { n: "03", key: "agency.how.s3" },
];

export function AgencyHowItWorks() {
  const { t } = useI18n();
  return (
    <section id="agency-how-it-works" className="py-24 px-6 scroll-mt-20" style={{ backgroundColor: "#06101e" }}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-4 text-white">
            {t("agency.how.title")}
          </h2>
          <p className="text-lg max-w-2xl mx-auto" style={{ color: "#94a3b8" }}>
            {t("agency.how.desc")}
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-5">
          {STEP_KEYS.map(({ n, key }) => (
            <div key={n} className="p-7 rounded-3xl" style={{ backgroundColor: "#0e2058", border: "1px solid #163554" }}>
              <div className="text-sm font-bold tracking-[0.2em] mb-4" style={{ color: "#e8721a" }}>
                {t("agency.how.step")} {n}
              </div>
              <h3 className="text-xl font-bold mb-2 text-white">{t(`${key}.title`)}</h3>
              <p className="text-sm leading-relaxed" style={{ color: "#94a3b8" }}>{t(`${key}.desc`)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
